<template>
  <div class="lms-wrapper-two">
    <student-nav></student-nav>
    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
      <div
        class="lms-content-body"
        style="bottom: 0; height: calc(100vh - 80px)"
      >





      <div class="row">
        <div class="col" v-for="(c, i) in calendarBox" :key="i">
          <div >
            <div class="d-flex pd-t-20 pd-b-10">
              <!-- <h3>Сургалтын календарь</h3> -->
              <ul class="nav nav-line mg-b-10" id="myTab5" role="tablist">
                <li class="nav-item" role="presentation">
                  <a @click="chngTb(0)" :class="`nav-link tx-semibold ${actvTb==0 ? 'active':''}`"  href="javascript:void(0)" role="tab" >Бүгд</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a @click="chngTb(1)"  :class="`nav-link tx-semibold ${actvTb==1 ? 'active':''}`" href="javascript:void(0)" role="tab" >Сургалт</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a @click="chngTb(2)"  :class="`nav-link tx-semibold ${actvTb==2 ? 'active':''}`" href="javascript:void(0)" role="tab">Төлөвлөгөө</a>
                </li>
              </ul>

              <div class="mg-l-auto d-flex">
                <div class="mg-r-10">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <a @click="prevnext(1,-1)" class="btn btn-white bd-r-0 rounded-20">
                        <feather type="chevron-left"></feather>
                      </a>
                    </div>
                    <input
                      disabled
                      type="text" style="width: 70px"
                      class="form-control bd-r-0 bd-l-0 text-center bg-white"
                      :value="`${yearCur} он`"
                    />
                    <div class="input-group-append">
                      <a @click="prevnext(1,1)" class="btn btn-white bd-l-0 rounded-20" >
                        <feather type="chevron-right"></feather>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <a @click="prevnext(2,-1)" class="btn btn-white bd-r-0 rounded-20">
                        <feather type="chevron-left"></feather>
                      </a>
                    </div>
                    <input
                      disabled
                      type="text" style="width: 80px"
                      class="form-control bd-r-0 bd-l-0 text-center bg-white"
                      :value="`${monthCur}-р сар`"
                    />
                    <div class="input-group-append">
                      <a @click="prevnext(2,1)" class="btn btn-white bd-l-0 rounded-20" >
                        <feather type="chevron-right"></feather>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <main class="calendargo">
              <div class="text-muted-xl" style="height: 18px;color: #999 !important; background: #e0e0e0;">Ня</div>
              <div class="text-muted-xl" style="height: 18px;background-color: #ffcc80; color: #FFF !important;">Да</div>
              <div class="text-muted-xl" style="height: 18px;background-color: #ffcc80; color: #FFF !important;">Мя</div>
              <div class="text-muted-xl" style="height: 18px;background-color: #ffcc80; color: #FFF !important;">Лх</div>
              <div class="text-muted-xl" style="height: 18px;background-color: #ffcc80; color: #FFF !important;">Пү</div>
              <div class="text-muted-xl" style="height: 18px;background-color: #ffcc80; color: #FFF !important;">Ба</div>
              <div class="text-muted-xl" style="height: 18px;color: #999 !important; background: #e0e0e0;">Бя</div>

              <div @click="showCourses(day)" class="timelog" style="position: relative"
                v-for="(day, index) in c.days" :key="index"
                :style="{ gridColumn: column(index, i), 'background': getTimeBg(day) }"
                :class="{ today: today(day) }" role="button"
              > 
                <div class="text-muted tx-16 tx-rubik" style="position: absolute; right: 3px; top: 3px">{{ day.format('D') }}</div>
                <div v-if="getTask(day).length>0" class="text-left tx-11 pd-l-5 pd-t-5 pos-absolute l-5 t-5">
                  <ol class="mg-l-10">
                    <li v-for="(t,ti) in getTask(day)" :key="ti">
                      <template v-if="t.objectTypeId==504">
                        <b>{{t.name}}</b>-г хүлээлгэн өгөх
                      </template>
                      <template v-else>
                        {{t.startDate | moment('HH:mm')}} - {{t.name}}
                      </template>                    
                    </li>
                  </ol>
                </div>
                <div v-else class="d-flex align-items-center vertical-align-middle text-center pos-absolute l-5 t-5">
                  <div>
                    <h6 class="tx-gray-600">
                        <img :src="`${myResBaseUrl}v4-assets/svgicon/education/outline/backpack.svg`" class="wd-16-f ht-16-f" style="width: 16px" />
                      ({{ getCourseCount(day) }})
                      </h6>
                  </div>
                </div>
                <div class="text-rows-3 mg-t-20 pd-5">
                {{ getNote(day) }}
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>


      </div>
    </div>

    <b-modal v-model="mdl.show" :title="mdl.title" scrollable centered>
      <div class="list-group">
        <div v-for="(c,i) in getCourseList(mdl.day)" :key="i" class="list-group-item" :style="`background: ${c.objectTypeId==585?'rgba(0,0,0,0.1)':''}`">
          <a @click="planMdlShow(c)" v-if="c.objectTypeId==585" style="display: block;" role="button">
            {{ c.name }} /төлөвлөгөө/
          </a>
          <router-link v-else-if="c.objectTypeId==504" :to="{ name: 'lmsLibrary',  params: { id: c.id, cid: 0, title: c.name, m: 5 } }">
            {{ c.name }} <sup>/ном захиалга/</sup>
          </router-link>
          <router-link v-else :to="{ name: 'lmsCourseView',  params: { id: c.id, bid: 0, iid: 0, bot: 0 } }">
            {{ c.name }}
          </router-link>
        </div>
      </div>
      <template #modal-footer>
          <div class="mg-l-auto btn-group">
            <button
              @click="editNotes()"
              type="button"
              class="btn btn-primary btn-xs btn-uppercase"
            >
              Тэмдэглэл бичих
            </button>
          </div>
        </template>
    </b-modal>

    <b-modal v-model="notes.modal" :title="`Тэмдэглэл`" scrollable centered>
      <div>
      <div>{{ mdl.day | moment('YYYY.MM.DD')}}</div>
        <Input
          type="textarea"
          :rows="4"
          placeholder="Тэмдэглэл бичнэ үү"
          v-model="notes.task.task">
        </Input>
      </div>
      <template #modal-footer>
      {{ notes.task.dueDate }}
          <div class="mg-l-auto btn-group">
            <button 
            @click="saveNotes"
              type="button"
              class="btn btn-info btn-xs btn-uppercase"
            >
              Хадгалах
            </button>
          </div>
        </template>
    </b-modal>
    <b-modal v-model="planMdl.show" :title="`Сургалтын төлөвлөгөө`" scrollable centered hide-footer>
      <div>
        <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Сургалт</label>
        <h6 class="tx-15 mg-b-10">{{ planMdl.obj.name }}</h6>
        <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Эхлэх</label>
        <h6 class="tx-15 mg-b-10">{{ planMdl.obj.d1 }}</h6>
        <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Дуусах</label>
        <h6 class="tx-15 mg-b-10">{{ planMdl.obj.d2 }}</h6>
        <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Тайлбар</label>
        <div class="tx-15 mg-b-10" v-html="planMdl.obj.taskDesc"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

// import FullCalendar from "@fullcalendar/vue";
// import dayGridPlugin from "@fullcalendar/daygrid";
//import interactionPlugin from '@fullcalendar/interaction'
import { request } from "@/api/all";
import { formatDateYM } from "@/libs/tools";

const moment = require("moment");

// import { ref } from 'vue';
// const calendar = ref(null);

import "element-ui/lib/theme-chalk/index.css";
import { Input } from "element-ui";

export default {
  components: {
    Input,
    // FullCalendar, // make the <FullCalendar> tag available
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();

    return {
      actvTb: 0,
      myResBaseUrl: "https://res.gosmart.mn/",

      calendarBox: [],
      monthStart: 0,
      yearCur: null,
      monthCur: null,

      // attributes: [],
      // myFromPage: {
      //   year: null,
      //   month: null
      // },

      // calendarOptions: {
      //   headerToolbar: {
      //     left: "prev,next,today",
      //     center: "title",
      //     right: "dayGridMonth,dayGridWeek,dayGridDay"
      //   },
      //   plugins: [
      //     dayGridPlugin //, interactionPlugin
      //   ],
      //   initialView: "dayGridMonth",
      //   dateClick: this.handleDateClick,
      //   events: [
      //     // { id: "guid-1", title: "event 1", date: "2021-04-08" },
      //     // { id: "guid-2", title: "event 2", date: "2021-04-12" }
      //   ],
      //   eventClick: this.showInfoModal
      // },

      // navbarMode: 0,

      // masks: {
      //   weekdays: "WWW"
      // },
      // // attributes: [
      // //   {
      // //     key: 1,
      // //     customData: {
      // //       title: "Lunch with mom.",
      // //       class: "bg-red-600 text-white"
      // //     },
      // //     dates: new Date(year, month, 1)
      // //   }
      // // ],
      calendarData: [],
      // showModal: false,
      // current: {}
      mdl:{
        show: false,
        title: '',
        day: null,
        courses: []
      },
      notes:{
        tasks: [],
        task: {
          id: 0,
          task: null,
          dueDate: null
        },
        modal: false,
      },
      planMdl:{
        show: false,
        obj: {
          name: null,
          startDate: null,
          endDate: null
        }
      },
    };
  },
  mounted() {
    // this.myFromPage.year= moment(new Date()).format('YYYY');
    // this.myFromPage.month= moment(new Date()).format('MM');
    // // this.toggleBodyClass("addClass", "app-lms");
    // // require("@/assets/scss/pages/calendar.scss");
    // // require("@/assets/css/dynamic.lms.css");
    this.yearCur= parseInt(moment(new Date()).format('YYYY'), 10);
    this.monthCur= parseInt(moment(new Date()).format('MM'), 10);
    this.fetchData();
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },

  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  watch: {
    // // whenever question changes, this function will run
    // myFromPage: function (newQuestion, oldQuestion) {
    //   //console.log(newQuestion, oldQuestion);
    //   //this.answer = 'Waiting for you to stop typing...'
    //   this.fetchData();
    // }
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    chngTb(tb){
      this.actvTb= tb;
      this.fetchData();
    },
    saveNotes(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: {
          model: this.notes.task
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.notes.modal= false;
          this.mdl.show= false;
          this.fetchNotes();
          // this.modal.show = false;
          // this.fetchData();
          //this.$emit("on-reload");
        }
      });
    },
    editNotes(){
      let _ot = this.$store.state.app.groupDefaultProjects.filter( x => x.objectTypeId == 583 );
      let _prjid= 0;
      if (_ot.length) {
        _prjid = _ot[0].id;
      }

      let tskId=0;

      let _tsk= this.notes.tasks.filter(x=>moment(x.dueDate).isSame(moment(this.mdl.day), 'day'));
      if(_tsk.length){
        tskId= _tsk[0]['id'];
      }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: tskId,
          boxId: 0,
          parentId: 0,
          objectTypeId: 583,
          projectId: _prjid
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.notes.task= res.data.task;
          //console.log('conv date', this.mdl.day, moment(this.mdl.day, 'YYYY.MM.DD 00:00:00'));
          this.notes.task.dueDate= moment(this.mdl.day, 'YYYY.MM.DD 08:00:00').format('YYYY.MM.DD') ;
          this.notes.modal= true;
        }
      });
    },
    prevnext(mode, option){
      if(mode==1){
        if(option>0){
          this.yearCur++;
          this.monthCur= 1;
        }else{
          this.yearCur--;
          this.monthCur= 12;
        }
      }else if(mode==2){
        if(option>0){
          if(this.monthCur<12){
            this.monthCur++;
          }else{
            this.yearCur++;
            this.monthCur= 1;
          }
        }else{
          if(this.monthCur>1){
            this.monthCur--;
          }else{
            this.yearCur--;
            this.monthCur= 12;
          }
        }
      }
      this.$nextTick(()=>{
        this.fetchData();
      });
    },
    column(index, i) {
      if (index == 0) {
        return this.calendarBox[i].days[0].day() + 1;
      }
    },
    today(day) {
      return moment().isSame(day, "day");
    },
    showCourses(day){
      //console.log('this.calendarData', this.calendarData.filter(x=> moment((x.objectTypeId==115?x.startDate : x.endDate), 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD'))));
      //if(this.calendarData.filter(x=>moment(x.startDate, 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD'))).length){
        this.mdl.courses= this.calendarData.filter(x=> moment((x.objectTypeId==115?x.startDate : x.endDate), 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD')));
        this.mdl.title=day.format('YYYY.MM.DD');
        this.mdl.day=day;
        this.mdl.show= true;
      //}
    },
    getTask(day){
      //console.log('getTask', day.format('D'), this.calendarData.filter(x=>moment(x.startDate, 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD'))).length);
      let rv=[];
      var testDate = moment(day, "DD/MM/YYYY");
      //console.log(this.calendarData.filter(x=>moment(x.startDate, 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD'))).length, testDate);

      if(this.calendarData.filter(x=>moment(x.startDate, 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD'))).length){
        rv= this.calendarData.filter(x=>moment(x.startDate, 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD')));
        //console.log('day.format(D)', day.format('D'), rv);
      }
      //rv= this.calendarData;
      return rv;
    },
    getCourseCount(day){
      let rv=0;
      rv= this.calendarData.filter(x=>day.isBetween(x.startDate, x.endDate)).length;
      return rv;
    },
    getCourseList(day){
      let rv=[];
      rv= this.calendarData.filter(x=>
      x.objectTypeId==115? moment(day, 'YYYY/MM/DD').isBetween(x.startDate, x.endDate)
      : moment(x.endDate, 'YYYY/MM/DD').isSame(moment(day, 'YYYY/MM/DD')) );
      return rv;
    },

    planMdlShow(obj){
      this.planMdl.obj= obj;
      this.planMdl.show= true;
    },

    getTime(flag, date){
      let rv='';
      // let rrr= '';
      // if(this.logData.log !=undefined && this.logData.log.length>0){
      //   rrr= this.logData.log[0].logTime.filter(x=>x.time!=null &&  x.flag==flag && 
      //   moment(x.time, 'YYYY/MM/DD').isSame(moment(date, 'YYYY/MM/DD')) )
      //   if(rrr.length>0){
      //     if(rrr[0].type==null || rrr[0].type=='')
      //     rv=rrr[0].timeSpan.substring(0,5);
      //     else if(flag==2) rv=rrr[0].type
      //   }
        
      // }
      return rv;
    },
    getTimeBg(date){
      //console.log('date', date);
      //.format('YYYY-MM-DD')
      let rv='';
      let rrr= '';
      // if(this.logData.log !=undefined && this.logData.log.length>0){
      //   rrr= this.logData.log[0].logTime.filter(x=>x.time!=null && 
      //   moment(x.time, 'YYYY/MM/DD').isSame(moment(date, 'YYYY/MM/DD')) )
      //   if(rrr.length>0){
      //     if(rrr[0].type==null || rrr[0].type=='')
      //     {
      //       if(rrr[0].zoruu>0)
      //         rv= '#ffcc80';
      //     }
      //     else rv='lightgray'
      //   }
        
      // }
      if(this.calendarData.filter(x=>x.objectTypeId==585 && date.isBetween(x.startDate, x.endDate)).length){
        rv='rgba(0,0,0,0.1)';
      }
      return rv;
    },

    // moveToday(){
    //   calendar.value.move(new Date());
    // },
    fetchData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/GetCourseCalendarData" },
        data: { 
          startDate: moment(this.yearCur+'.'+this.monthCur).startOf('month').format('YYYY-MM-DD'), 
          endDate: moment(this.yearCur+'.'+this.monthCur).endOf('month').format('YYYY-MM-DD'), 
          mode: this.actvTb
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res.data.list', res.data);
          this.calendarData = res.data.courses;
          this.init();
        }
      });

      this.fetchNotes();
    },
    fetchNotes(){
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 583,
          model: { 
            //isPublic: true, locTypeId1: cid 
            dueDateSearchStart: moment(this.yearCur+'.'+this.monthCur).startOf('month').format('YYYY-MM-DD'),
            dueDateSearchEnd: moment(this.yearCur+'.'+this.monthCur).endOf('month').format('YYYY-MM-DD') 
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('res.data.tasks', res.data);
          this.notes.tasks = res.data.tasks;
        }
      });
    },
    getNote(day){
      let rv='';
      let _tsk= this.notes.tasks.filter(x=>moment(x.dueDate).isSame(moment(day), 'day'));
      if(_tsk.length){
        rv= _tsk[0]['task'];
      }
      return rv;
    },
    init() {
      let _dt= this.yearCur+"/"+this.monthCur+"/01";
      let self = this;
      self.calendarBox = [];
      for (var i = self.monthStart; i < self.monthStart + 1; i++) {
        //let md = moment(new Date().setMonth(new Date().getMonth() + i)).startOf("month");
        let md = moment(_dt).add(i, 'month').startOf('month');
        //console.log(formatDateYM(md, 'оны ')+'-р сар');
        //console.log(md)

        self.calendarBox.push({
          title: formatDateYM(md, " оны ") + "-р сар",
          days: [...Array(md.daysInMonth())].map((_, i) =>
            md.clone().add(i, "day")
          )
        });
      }

    //   // let arr1 = this.calendarData.map(e => {
    //   //   return {
    //   //     id: e.id,
    //   //     title: e.name,
    //   //     date: e.startDate,
    //   //     start: e.startDate,
    //   //     end: e.startDate,

    //   //     course:{
    //   //       name: e.name,
    //   //     }
    //   //   };
    //   // });

    //   // var merge = _.concat(arr1, this.calendarData.map(e => {
    //   //   return {
    //   //     id: e.id,
    //   //     title: e.name+' дуусах',
    //   //     date: e.endDate,
    //   //     start: e.endDate,
    //   //     end: e.endDate,

    //   //     course:{
    //   //       name: e.name,
    //   //     }
    //   //   };
    //   // }));

    //   this.attributes= this.calendarData.map(x=>{
    //         return{
    //           // key: any,
    //           dot: true,
    //           //bar: true,
    //           // highlight: {
    //           //   start: { fillMode: 'solid' },
    //           //   base: { fillMode: 'light' },
    //           //   end: { fillMode: 'solid' },
    //           // },
    //           popover: {
    //             label: `${x.name} (${moment(x.startDate).format('YYYY.MM.DD HH:mm')}-${moment(x.endDate).format('YYYY.MM.DD HH:mm')})`,
    //           },
    //           dates: {start: x.startDate, end:x.endDate },
    //         }
    //       })
    },
    // toggleBodyClass(addRemoveClass, className) {
    //   const el = document.body;

    //   if (addRemoveClass === "addClass") {
    //     el.classList.add(className);
    //   } else {
    //     el.classList.remove(className);
    //   }
    // },
    // showInfoModal(e) {
    //   let filtered = this.calendarData.filter(x => x.id == e.event.id);
    //   if (filtered.length > 0) {
    //     this.showModal = true;
    //     this.current = filtered[0];
    //   }
    // },
    // cancel() {
    //   this.showModal = false;
    // }
  }
};
</script>
<style lang="scss">
.calendargo{
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  max-width: 100vw;
  width: 100%;
}

.calendargo > * {
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 21px;
  border: 1px solid rgba(0,0,0,.05);
  cursor: pointer;
  height: 13vh;
}

.calendargo > *::before {
  content: "";
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 1px;
}

.calendargo > *.today{
  // color: #2bafb4;
  border: 0.1em solid white;
  // border-radius: 100%;
  font-weight: bold;
  background: rgba(43, 175, 180, 0.5) !important;
}

.calendargo > *.active{
  border-radius: 100%;
  background: rgb(43, 175, 180);
  color: #fff;
}

.calendargo > .timelog{
  justify-content: flex-start !important;
  align-items: flex-start !important;
  color: #666;
  line-height: 1.2;
  padding-right: 20px;
  overflow: hidden;
  background-color: white;
}
  // .vc-full-page{
  //   height: auto;
  //   .vc-pane-layout{
  //     height: 75vh;
  //     .vc-day{
  //       border: 1px solid #fcfcfc;
  //       height: 10vh;

  //       &.vc-today{
  //         background: rgba(0,0,0,0.2);
  //       }
  //     }
  //   }
  // }
</style>